module.exports = __webpack_public_path__ + "88c1e212ccab7ae47079a2003f0c14e0.svg";